import { API_NAME_PARAM_KEY } from '../const'
import request, { ApiConfig, AxiosRequestConfig } from '../request'

type GetAxiosRequestConfig = Omit<AxiosRequestConfig, 'method' | 'data' | 'params'>

/**
 * get请求
 * @param name 接口名称
 * @param data 请求参数
 * @param custom 自定义配置
 * @param config axios配置
 */
export default function post<RESD, REQD> (name: string, data?: REQD, custom?: ApiConfig, config?: GetAxiosRequestConfig) {
  const params: any = {}

  if (name) {
    params[API_NAME_PARAM_KEY] = name
  }

  return request<RESD, REQD>({
    ...config,
    method: 'POST',
    data,
    params,
  }, custom)
}
